import { TabIds } from '../../constants/conectividad';

export const AGENDA_DE_TURNOS = 'agenda-de-turnos';

const menuDesplegableItems = [
  {
    section: {
      id: 'tramites-online',
      description: 'TRAMITES ONLINE',
      menu: [
        {
          id: 'consulta-de-facturas/pagos',
          route: `/tramitesonline/consulta-pagos-facturas`,
          description: 'Consulta de facturas y pagos',
          type: 'route',
        },
        {
          id: 'consulta-de-liquidacion',
          route: `/tramitesonline/consulta-de-liquidacion`,
          description: 'Consulta de liquidación',
          type: 'route',
        },
        {
          id: 'validador-de-asociados',
          route: `/tramitesonline/validar-afiliado`,
          description: 'Validador de Asociados',
          type: 'route',
        },
        {
          id: 'datos-personales',
          route: `/tramitesonline/datos-personales`,
          description: 'Datos Personales',
          type: 'route',
        },
        {
          id: 'tramites-de-autorizaciones',
          route: `/tramitesonline/tramites-de-autorizaciones`,
          description: 'Trámites de autorizaciones',
          type: 'route',
        },
        {
          id: 'ingreso-de-prestaciones',
          route: `/tramitesonline/tramites-conectividad#${TabIds.ENTER_BENEFIT}`,
          description: 'Ingreso De Prestaciones',
          type: 'route',
        },
        {
          id: 'busqueda-de-tickets',
          route: `/tramitesonline/tramites-conectividad#${TabIds.BENEFITS}`,
          description: 'Búsqueda de Tickets',
          type: 'route',
        },
        {
          id: 'reportes',
          route: `/tramitesonline/tramites-conectividad#${TabIds.REPORTS}`,
          description: 'Reportes',
          type: 'route',
        },
        /* {
          id: "elegibilidad",
          `route: tramitesonline/tramites-conectividad#${TABS.ELEGIBILIDAD}`,
          description: "Elegibilidad",
          type: "route",
        }, */
        {
          id: 'censos',
          route: `/tramitesonline/censos`,
          description: 'Censos',
          type: 'route',
        },
        {
          id: AGENDA_DE_TURNOS,
          route: '/',
          description: 'Agenda de Turnos',
          type: 'redirect',
        },
      ],
    },
  },
  {
    section: {
      id: 'cap',
      description: 'CAP WEB',
      menu: [
        {
          id: 'centro-de-atencion-al-prestador',
          route: `/tramitesonline/capweb`,
          description: 'Centro de Atención a Prestadores',
          type: 'route',
        },
      ],
    },
  },
  {
    section: {
      id: 'gestion-usuarios',
      description: 'GESTION DE USUARIOS',
      menu: [
        {
          id: 'gestion-usuarios',
          route: `/gestionusuarios`,
          description: 'Gestionar Usuarios',
          type: 'route',
        },
        {
          id: 'registrar-usuarios',
          route: `/gestionusuarios/registrar-usuario`,
          description: 'Registrar usuarios',
          type: 'route',
        },
      ],
    },
  },
];

export default menuDesplegableItems;
